import React from 'react';
import { css } from '@emotion/core';

export default function LoadingClient() {
    return (
        <div css={css(wrapperStyle)}>
            <div css={css(iconStyle)} />
        </div>
    );
}

const wrapperStyle = `
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;
`;

const iconStyle = `
    margin: auto;
    position: fixed;
    height: 106px;
    width: 106px;
    background-image: url(https://assets.fevercdn.com/promotion/img/loading-ellipsis.svg);
    background-repeat: no-repeat;
    z-index: 99999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    &:before {
        content: '';
        height: 100%;
        width: 100%;
    }
`;
